import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";

import FDRefImg from "@/assets/images/landingPage/AslowAsCategoryBanners/4JS24-ASA-Banners-French_Ref.png";
import DishwasherImg from "@/assets/images/landingPage/AslowAsCategoryBanners/4JS24-ASA-Banners-Dish.png";
import WasherDryerImg from "@/assets/images/landingPage/AslowAsCategoryBanners/4JS24-ASA-Banners-Washer_Dryer_Set.png";

import Image from "next/image";
import DynamicImage from "../DynamicImages/DynamicImage";
import Link from "next/link";

const BannerImg = [
  {
    src: FDRefImg,
    link: "/in-stock?subCategory2Ids=366",
    title: "French Door Refrigerators",
  },
  {
    src: DishwasherImg,
    link: "/in-stock?categoryIds=350",
    title: "Dishwashers",
  },
  {
    src: WasherDryerImg,
    link: "/laundry/washer-dryer-sets?page=1&isAvailabilty=true",
    title: "Washer & Dryer Sets",
  },
  
  // {
  //   src: GasRangesImg,
  //   link: "/ranges/gas-ranges?page=1&isAvailabilty=true",
  //   title: "Gas Ranges",
  // },
  // {
  //   src: MicrowavesImg,
  //   link: "/microwaves-otr?page=1&isAvailabilty=true",
  //   title: "Microwaves",
  // },
];

const AsLowAs = ({updateBreadcrumb}) => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    const updateCount = () => {
      setCount(api.scrollSnapList().length);
      setCurrent(api.selectedScrollSnap() + 1);
    };

    updateCount(); // Initial count and current slide set

    api.on("reInit", updateCount); // Ensure count updates on re-initialization
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });

    return () => {
      api.off("reInit", updateCount);
      api.off("select");
    };
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  return (
    <div>
      <Carousel
        opts={{
          align: "start",
        }}
        className="w-full pb-[48px] lg:pb-6 viewedCard570:hidden"
        setApi={setApi}
      >
        <CarouselContent className="m-0">
          {BannerImg.map((item, index) => (
            <CarouselItem
              key={index}
              className="basis-1/3 m-0 eventPage:basis-1/2"
            >
              <Link
                href={item.link}
                onClick={() => {
                  updateBreadcrumb([
                    {
                      name: item.title,
                      url: item.link,
                    },
                  ]);
                }}
              >
                <div className="px-[23px]">
                  <AspectRatio ratio={435 / 217} className="bg-muted">
                    <Image
                      src={item.src}
                      alt={`Banner ${index + 1}`}
                      fill
                      className="h-full w-full rounded-md object-cover"
                    />
                  </AspectRatio>
                </div>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        {api?.scrollSnapList()?.length > 1 &&
<div className=" grid grid-cols-[1fr_auto] items-center gap-3 px-[23px] ">
          {/* Clickable Pagination Dots */}
          <div className="flex justify-center ">
            {Array.from({ length: count }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-full h-1  transition-all ${
                  current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                }`}
              />
            ))}
          </div>
          {/* Navigation Buttons */}
          <div className="flex items-center justify-end gap-3">
            <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
            <div className="text-sm text-[#0C2340] font-medium">
              {current}/{count}
            </div>
            <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
          </div>
        </div>
        }
        
      </Carousel>
      <div className="viewedCard570:block px-4 hidden ">
        {BannerImg.map((item, index) => (
          <div
            key={index}
            className="py-[7px] viewedCard570:pt-0 viewedCard570:pb-3"
          >
            <Link
              href={item.link}
              onClick={() => {
                updateBreadcrumb([
                  {
                    name: item.title,
                    url: item.link,
                  },
                ]);
              }}
            >
              <AspectRatio
                ratio={368 / 184}
                className="bg-muted rounded-10 overflow-hidden"
              >
                <Image
                  src={item.src}
                  alt={`Banner ${index + 1}`}
                  fill
                  className="h-full w-full rounded-md object-cover"
                />
              </AspectRatio>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsLowAs;
